import React, {useState} from 'react';
import { Link } from "react-router-dom";

import './AppShell.css';

import {
  // Content,
  Header,
  // HeaderMenuButton,
  HeaderName,
  // HeaderNavigation,
  // HeaderMenu,
  // HeaderMenuItem,
  HeaderGlobalBar,
  HeaderGlobalAction,
  HeaderPanel,
  // HeaderSideNavItems,
  // SkipToContent,
  // SideNav,
  // Temporarily comment these out until they are needed again
  // SideNavHeader,
  // SideNavDetails,
  // SideNavSwitcher,
  // SideNavItems,
  // SideNavLink,
  // SideNavMenu,
  // SideNavMenuItem,
  Switcher,
  SwitcherItem,
  SwitcherDivider,
} from 'carbon-components-react';

import { Notification20, Menu20 } from '@carbon/icons-react';

import headerLogo from '../../cwc-logo-white-v1-1.png';
import keennLogoKWhite from '../../keenn-logo-k-white.png';

function AppShell(props) {
  const {user, logout} = props
  const [menu, setMenu] = useState(false)

  const _handleClickMenuItem = () => {
    console.log("clik close!!");
    setMenu(!menu)
  }

  return (
    <div>
      <Header aria-label="CWC Platform" >
        <HeaderName id="logoLinkContainer" href="/" prefix="">
          <img width="190" src={headerLogo} />
       </HeaderName>
       <HeaderGlobalBar>

         {/*<HeaderGlobalAction
           aria-label="Notifications"
           onClick={() => console.log('notification click?')}>
           <Notification20 />
         </HeaderGlobalAction> */}

         <HeaderGlobalAction
           aria-label="App Switcher"
           isActive
           onClick={ () => setMenu(!menu)}>
           <Menu20 />
         </HeaderGlobalAction>

       </HeaderGlobalBar>
       <HeaderPanel aria-label="Header Panel" expanded={menu}>
         <Switcher aria-label="Switcher Container">
           <div className="bx--switcher__item">
             <Link onClick={(e) => _handleClickMenuItem(e)} className="bx--switcher__item-link" to="/">Live Inventory</Link>
           </div>
           <div className="bx--switcher__item">
             <Link onClick={(e) => _handleClickMenuItem(e)} className="bx--switcher__item-link" to="/image-Management">Image Management</Link>
           </div>
           <div className="bx--switcher__item">
             <Link onClick={(e) => _handleClickMenuItem(e)} className="bx--switcher__item-link" to="/quote-creator">Quote Creator</Link>
           </div>
           <div className="bx--switcher__item">
             <Link onClick={(e) => _handleClickMenuItem(e)} className="bx--switcher__item-link" to="/quote-database">Quote Database</Link>
           </div>
           <div className="bx--switcher__item">
             <Link onClick={(e) => _handleClickMenuItem(e)} className="bx--switcher__item-link" to="/sales-order-database">Sales Order Database</Link>
           </div>
           {/*<SwitcherItem href="#" aria-label="Link 5">
             Documentation
           </SwitcherItem> */}
           <SwitcherDivider />
           <SwitcherItem id="logout-menu-section" href="/" onClick={ () => logout()} aria-label="Link 6">
             <strong>Log Out</strong> <span id="userEmailLogoutBtn">[{user.email}]</span>
           </SwitcherItem>
         </Switcher>
{/*         <div id="poweredBy"><div id="poweredByText">Powered by Keenn</div></div>
*/}       </HeaderPanel>

     </Header>
     <div id="appContent">
       {props.children}
     </div>
    </div>

  );
}

export default AppShell;
